DownloadHelpService.$inject = [];
/**
 * @ngdoc service
 * @name mx.shell.DownloadHelpService
 * @module mx.shell
 *
 * @description
 * Provides methods for downloading files
 **/
export function DownloadHelpService() {
	function tryGetFileName(fileName) {
		if (fileName && fileName.split) {
			let tempFileName = fileName.split(';')[1];

			if (tempFileName) {
				tempFileName = tempFileName.trim().split('=')[1];

				if (tempFileName) {
					return decodeURI(tempFileName).replace(/"/g, '') || 'NoFileName.dat';
				}
			}
		}

		return 'NoFileName.dat';
	}

	/**
	 * @ngdoc method
	 * @name mx.shell.DownloadHelpService#downloadContent
	 *
	 * @param {object} response - Http response object
	 * @param {ArrayBuffer} data - Contents of the file to be downloaded
	 * @param {string} forceFileName - A name of a file to be downloaded.
	 * If not specified - file name will be attempted to get from response headers
	 *
	 * @returns {boolean} If false - there were no sufficient data to download a file.
	 *
	 * @description
	 * Used as a success response callback to save response to a file
	 */
	function downloadContent(response, data, forceFileName) {
		if (!response) {
			return false;
		}

		data = data || response.data;

		if (!data) {
			return false;
		}

		const file = new Blob([data], { type: response.headers('content-type') });
		const fileName = forceFileName || tryGetFileName(response.headers('Content-Disposition'));

		const isChrome = !!window.chrome && (/Google Inc/.test(window.navigator.vendor) || !!window.chrome.webstore);

		const isFf = /Firefox/.test(window.navigator.userAgent);

		const isEdge = !!window.StyleMedia;
		const urlLocal = URL || window.URL || window.webkitURL;
		const link = angular.element('<a></a>');
		if (isFf || isChrome) {
			const urlObj = urlLocal.createObjectURL(file);
			const a = link[0];
			document.body.appendChild(a);
			link.attr('href', urlObj);
			link.attr('target', '_self');
			link.attr('download', fileName);
			a.click();

			setTimeout(function () {
				document.body.removeChild(a);
				urlLocal.revokeObjectURL(urlObj);
			}, 100);
		} else if (isEdge) {
			window.navigator.msSaveOrOpenBlob(file, fileName);
		} else {
			const fileUri = URL.createObjectURL(file);
			window.open(fileUri);
		}

		return true;
	}

	return { downloadContent: downloadContent };
}
